import Nullstack from 'nullstack';
export default function IconClockRecord({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-clock-record",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20.995 12.3a9 9 0 1 0 -8.683 8.694"
  }), "   ", Nullstack.element("path", {
    d: "M12 7v5l2 2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "19",
    r: "3"
  }), " ");
}